export const MODE = {
    CREATE: 'creating',
    UPDATE: 'editing',
    CLONE: 'cloning',
    POLY: 'poly',
}